import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { SurveyForm } from './SurveyForm';
import { SurveyComplete } from './SurveyComplete';
export function SurveyLanding() {
    const { campaignId } = useParams();
    const [surveyData, setSurveyData] = useState(null);
    const [error, setError] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const lang = navigator.language.startsWith('pl') ? 'pl' : 'en';
    useEffect(() => {
        fetch(`/api/survey/${campaignId}`)
            .then(r => {
            if (!r.ok)
                throw new Error(r.status === 410 ? 'expired' : 'not_found');
            return r.json();
        })
            .then(r => setSurveyData(r.data))
            .catch(e => setError(e.message));
    }, [campaignId]);
    if (error === 'expired') {
        return (_jsx("div", { className: "min-h-screen bg-stone-50 flex items-center justify-center p-4", children: _jsx("div", { className: "text-center", children: _jsx("h1", { className: "text-xl font-semibold text-stone-900 mb-2", children: lang === 'pl' ? 'Ta ankieta została zamknięta.' : 'This survey has closed.' }) }) }));
    }
    if (error) {
        return (_jsx("div", { className: "min-h-screen bg-stone-50 flex items-center justify-center p-4", children: _jsx("div", { className: "text-center text-stone-500", children: "Survey not found." }) }));
    }
    if (!surveyData) {
        return (_jsx("div", { className: "min-h-screen bg-stone-50 flex items-center justify-center", children: _jsx("div", { className: "text-stone-400", children: "Loading..." }) }));
    }
    if (submitted)
        return _jsx(SurveyComplete, { lang: lang });
    return _jsx(SurveyForm, { surveyData: surveyData, lang: lang, onComplete: () => setSubmitted(true) });
}
